



































import { mapActions } from 'vuex'

export default {
  data: () => ({
    form: {
      email: '',
      password: ''
    },
    show_password: false,
    rules: {
      required: (v: any) => !!v || 'Obligatorio.',
      email_rules: [
        (v: any) => !!v || 'el email es obligatorio',
        (v: any) => /.+@.+/.test(v) || 'El email debe ser valido'
      ]
    }
  }),
  methods: {

    ...mapActions('auth', [
      'login'
    ]),

    async handleSubmit () {
      let suscess: boolean = await this.login({ email: this.form.email, password: this.form.password })
      // let suscess: boolean = await UserAuthService.login(this.form.email, this.form.password);
      if (suscess === true) {
        this.$emit('login_suscesful')
      }
    }
  }
}
